import React from 'react'
import { FiCalendar } from 'react-icons/fi'
import { theme } from '../../../../theme'
import IconBackground from './IconBackground'

function ICalendarIcon({ size = 1, color = theme.colors.palette.icalendar }) {
  return (
    <IconBackground size={size} color={color}>
      <FiCalendar style={{ color: 'white' }} size={16 * size} />
    </IconBackground>
  )
}

export default ICalendarIcon
